import React, { useState, useEffect, Fragment }  from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import CreditCardIcon from '@material-ui/icons/CreditCard';

import Loading from 'app/components/loaders/Loading';

import { paper } from 'app/styles/core';
import { container } from 'app/styles/new-layout';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    container: {
        ...container(theme),
        padding: theme.spacing(3),
    },
    marginBottom: {
        marginBottom: theme.spacing(1)
    },
    marginRight: {
        marginRight: theme.spacing(3)
    },
    paper: {
        ...paper(theme),
        position: 'relative',
        marginBottom: theme.spacing(3)
    },
    paperEmpty: {
        padding: theme.spacing(6),
        textAlign: 'center'
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        color: '#ffffff'
    },
    avatarSuccess: {
        backgroundColor: theme.palette.success.main,
        color: '#ffffff'
    },
    bankAccount: {
        marginTop: theme.spacing(3),
        borderWidth: 1,
        borderColor: theme.palette.success.light,
        borderStyle: 'solid',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(3)
    },
    card: {
        marginTop: theme.spacing(3),
        borderWidth: 1,
        borderColor: theme.palette.primary.light,
        borderStyle: 'solid',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(3)
    },
    flexGrow: {
        flexGrow: 1
    }
}));

export default function Accounts(props) {

    const [ bankAccounts, setBankAccounts ] = useState(null);
    const [ cards, setCards ] = useState(null);

    const [ loading, setLoading ] = useState(false);

    const classes = useStyles();
    const api = useApi();

    // GETTERS ------------------------------------------------

    const getAccounts = () => {
        setLoading(true);

        api.get('/admin/accounting/stripe/accounts')
            .then((res) => {
                setBankAccounts(res.bankAccounts);
                setCards(res.cards)
            }).catch((error) => {
                //console.log(error)
            }).then(() => setLoading(false));
    }

    useEffect(() => {
        getAccounts();
    }, [])

    // SETTERS ------------------------------------------------



    // POSTERS ------------------------------------------------


    return (
        <form className={classes.container} noValidate autoComplete="off">
            <Loading isLoading={loading}/>
            <Paper className={classes.paper}>
                <Typography variant="h4">
                    Bank Accounts
                </Typography>
                { (bankAccounts && bankAccounts.data.length) ? bankAccounts.data.map((account) => (
                    <div key={account.id} className={classes.bankAccount}>
                        <Grid container spacing={3}>
                            <Grid item>
                                <Avatar className={classes.avatarSuccess}>
                                    <AccountBalanceIcon />
                                </Avatar>
                            </Grid>
                            <Grid item className={classes.flexGrow}>
                                <Typography component="div" variant="h6">
                                    {account.bank_name}
                                </Typography>
                                <Typography component="div" variant="subtitle2">
                                    <Typography component="span" color="textSecondary" variant="subtitle2">
                                        Account #:&nbsp;
                                    </Typography>
                                    {account.last4}&nbsp;&nbsp;&nbsp;
                                    <Typography component="span" color="textSecondary" variant="subtitle2">
                                        Account Holder:&nbsp;
                                    </Typography>
                                    {account.account_holder_name}
                                </Typography>
                            </Grid>
                            <Grid item>

                            </Grid>
                        </Grid>
                    </div>
                )) : (
                    <div className={classes.paperEmpty}>
                        <Typography component="div" variant="h6" color="textSecondary">
                            You do not have any connected bank accounts.
                        </Typography>
                    </div>
                )}
            </Paper>
            <Paper className={classes.paper}>
                <Typography variant="h4">
                    Cards
                </Typography>
                { (cards && cards.data.length) ? cards.data.map((card) => (
                    <div key={card.id} className={classes.card}>
                        <Grid container spacing={3}>
                            <Grid item>
                                <Avatar className={classes.avatar}>
                                    <CreditCardIcon />
                                </Avatar>
                            </Grid>
                            <Grid item className={classes.flexGrow}>
                                <Typography component="div" variant="h6">
                                    {card.brand} {card.last4}
                                </Typography>
                                <Typography component="div" variant="subtitle2">
                                    <Typography component="span" color="textSecondary" variant="subtitle2">
                                        Expires:&nbsp;
                                    </Typography>
                                    {card.exp_month}/{card.exp_year}
                                </Typography>
                            </Grid>
                            <Grid item>

                            </Grid>
                        </Grid>
                    </div>
                )) : (
                    <div className={classes.paperEmpty}>
                        <Typography component="div" variant="h6" color="textSecondary">
                            You do not have any connected credit or debit cards.
                        </Typography>
                    </div>
                )}
            </Paper>
        </form>
    )
}
